<template>
    <div>
        <kt-datatable ref="datatable" v-bind="datatableProps" v-on:change="$emit('filter', $event)"></kt-datatable>
    </div>
</template>

<script>
import {StarShopApiUrl} from "@/common/api.service";
import {AuthorizationHeader} from "@/common/jwt.service";
import manageColumns from './datatable/columnsWithManageAccess_customers';
import actionsColumnWithManageAccess from './components/actionsColumnWithManageAccessCustomer'

export default {
    name: 'customers-with-manage',
    props: {
        query: {
            type: Object,
            required: true
        }
    },
    computed: {
        datatableProps() {
            return {
                id: 'datatableWithManageAccess',
                data: {
                   type: 'remote',
                   source: {
                       read: {
                           url: StarShopApiUrl.path('customer/admin/'),
                           method: 'GET',
                           headers: AuthorizationHeader,
                           map: function(res) {
                               return res.data.data
                           },
                           params: {
                               query: this.query 
                           },
                       }
                   },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                layout: {
                },
                pagination: false,
                sortable: true,
                columns: manageColumns,
                actions: actionsColumnWithManageAccess
            }
        },
    },
    watch: {
        query: {
            handler(newQuery) {
                if (this.$refs.datatable.KTDatatable) {
                    this.$refs.datatable.reload();
                }
            },
            deep: true
        }
    }
}
</script>